export default __webpack_public_path__ + "static/media/email.ef4706a9.svg";